import React, {useEffect, useState} from 'react';
import {Layout, Menu, Typography, Dropdown, Space, theme} from 'antd';
import {
	FolderOutlined,
	UserOutlined,
	LogoutOutlined,
	SettingOutlined,
	ProfileOutlined,
} from '@ant-design/icons';
import {Outlet, useNavigate, useLocation} from 'react-router-dom';
import Logo from '@components/header/Logo';
import {useThemePalette} from '@/context/ThemeContext';
import {authApi} from '@/api/auth';
import Icons from '@components/icons';

const {Sider, Header, Content} = Layout;
const {Text} = Typography;

const SIDER_MENU_ITEMS_HOME = [{key: '/', icon: <FolderOutlined />, label: 'Проекты'}];

const SIDER_MENU_ITEMS_ACCOUNT = [
	{key: '/profile', icon: <ProfileOutlined />, label: 'Профиль'},
	{key: '/settings', icon: <SettingOutlined />, label: 'Настройки'},
];

const MainLayout: React.FC = () => {
	const [collapsed, setCollapsed] = useState(false);
	const [userName, setUserName] = useState<string>('');
	const navigate = useNavigate();
	const location = useLocation();
	const {themePreset} = useThemePalette();
	const {
		token: {colorBgContainer, borderRadiusLG, colorBorder},
	} = theme.useToken();
	const siderTheme = themePreset === 'dark' ? 'dark' : 'light';
	const isAccountSection = location.pathname === '/profile' || location.pathname === '/settings';
	const siderMenuItems = isAccountSection ? SIDER_MENU_ITEMS_ACCOUNT : SIDER_MENU_ITEMS_HOME;
	const selectedKey = isAccountSection
		? location.pathname
		: location.pathname === '/' || location.pathname.startsWith('/projects')
			? '/'
			: location.pathname;

	useEffect(() => {
		authApi.me().then(({data}) => {
			if (data?.name) setUserName(data.name);
		});
	}, []);

	const userMenuItems = [
		{
			key: 'profile',
			icon: <ProfileOutlined />,
			label: 'Профиль',
			onClick: () => navigate('/profile'),
		},
		{
			key: 'logout',
			icon: <LogoutOutlined />,
			label: 'Выйти',
			onClick: () => {
				void authApi.logout();
				navigate('/login');
			},
		},
	];

	return (
		<Layout>
			<Header
				style={{
					padding: '0 24px',
					display: 'flex',
					alignItems: 'center',
					background: colorBgContainer,
					justifyContent: 'space-between',
					boxShadow: '0 1px 4px rgba(0,21,41,0.08)',
					borderBottom: `1px solid ${colorBorder}`,
				}}
			>
				<Icons />
				<div
					onClick={() => navigate('/')}
					role="button"
					tabIndex={0}
					onKeyDown={e => e.key === 'Enter' && navigate('/')}
					style={{
						height: 64,
						display: 'flex',
						alignItems: 'center',
						paddingLeft: collapsed ? 16 : 24,
						borderBottom: '1px solid rgba(255,255,255,0.1)',
						cursor: 'pointer',
					}}
				>
					<Logo />
				</div>
				<Dropdown menu={{items: userMenuItems}} placement="bottomRight">
					<Space style={{cursor: 'pointer'}}>
						<UserOutlined style={{fontSize: 18}} />
						<Text>{userName || 'Пользователь'}</Text>
					</Space>
				</Dropdown>
			</Header>
			<Layout>
				<Sider
					theme={siderTheme}
					width={200}
					style={{background: colorBgContainer}}
					collapsible
					collapsed={collapsed}
					onCollapse={value => setCollapsed(value)}
				>
					<Menu
						theme={siderTheme}
						mode="inline"
						selectedKeys={[selectedKey]}
						items={siderMenuItems}
						onClick={({key}) => navigate(key)}
						style={{borderRight: borderRadiusLG, height: '100%'}}
					/>
				</Sider>
				<Layout style={{padding: '24px 24px 24px 14px', background: colorBgContainer}}>
					<Content
						style={{
							minHeight: 280,
							height: 'calc(100vh - 64px - 48px)',
							overflow: 'auto',
							background: colorBgContainer,
							borderRadius: borderRadiusLG,
							paddingLeft: 10,
						}}
					>
						<Outlet />
					</Content>
				</Layout>
			</Layout>
		</Layout>
	);
};

export default MainLayout;
